import { Column } from "primereact/column";
import { DataTableRowEditCompleteEvent, DataTable } from "primereact/datatable";
import { useState } from "react";

import { useInsulins } from "../../../services/useData";
import { InsulinType } from "../../../types/firestore";
import { NAME, Default } from "../../../util/const";


const InsulinTypes = () => {

  const fetchedInsulins = useInsulins();
  const insulins = fetchedInsulins.insulins;

  const [allInsulins, setAllInsulins] = useState(insulins);

  const onRowEditComplete = (e: DataTableRowEditCompleteEvent) => {
    let _rows = [...insulins];
    let { newData, index } = e;
    _rows[index] = newData as InsulinType;
    setAllInsulins(_rows);
  };

  return (
    <DataTable value={allInsulins} editMode="row" dataKey="id" onRowEditComplete={onRowEditComplete} showGridlines stripedRows>
      <Column field="name" header={NAME} style={{ width:'20%'}}></Column>
      <Column field="isDefault" header={Default} /*editor={(options) => numberEditor(options)}*/></Column>
      {/* <Column rowEditor={true}></Column> */}
    </DataTable>
  );
}

export default InsulinTypes;